/**
 * THE WARM SET (I1, L2-11): what the map asks for the moment it is created, loaded with the essential
 * packs so the loader's rings count it and "Enter" is offered when they close.
 *
 *   preload.warm(warmSet(workerUrl, prewarm));   // at boot, before preload.start()
 *
 *  - The MapLibre worker script. Once it is in, `onWorker` starts the worker pool (maplibregl.prewarm),
 *    so the workers parse and start while the packs are still arriving, not after 100 %.
 *  - The glyph ranges the opening views draw. Measured on the dev server with a request log: the full
 *    intro's region view at night and the home view both ask for exactly these four ranges.
 *
 * Pure (no MapLibre import) so tests can load it; App wires the worker URL and the prewarm.
 */
import type { WarmItem } from "@/features/loader/preload";
import { glyphsUrl } from "@/map/style/build";
import { FONTSTACKS } from "@/map/style/moods";

/** [fontstack, range] for the first view (§D label fonts: regular, medium, italic). */
export const FIRST_VIEW_GLYPHS: ReadonlyArray<readonly [fontstack: string, range: string]> = [
  [FONTSTACKS.bold, "0-255"],
  [FONTSTACKS.bold, "8192-8447"],
  [FONTSTACKS.regular, "0-255"],
  [FONTSTACKS.italic, "0-255"],
];

/** The glyph URLs exactly as MapLibre builds them from the style's template. */
export function firstViewGlyphUrls(template: string = glyphsUrl()): string[] {
  return FIRST_VIEW_GLYPHS.map(([fontstack, range]) => template.replace("{fontstack}", fontstack).replace("{range}", range));
}

export function warmSet(workerUrl: string, onWorker?: () => void, template?: string): WarmItem[] {
  return [{ url: workerUrl, onReady: onWorker }, ...firstViewGlyphUrls(template).map((url) => ({ url }))];
}
